
import React, { useState, useEffect } from 'react'
import axios from 'axios';
import {baseUrl, limit, animalType} from "../../../../../comman/config";
import Loader from "../../../../../comman/Loader";
import { PencilIcon, XCircleIcon } from '@heroicons/react/outline';
import {DateFilter} from "../../../../../comman/DateFilter.js";
import { useNavigate, Link } from 'react-router-dom';
import Pagination from "react-js-pagination";
import * as XLSX from 'xlsx';


function List() {

    const [distributorList, setDistributorList] = useState([]);
    const [companyList, setCompanyList] = useState([]);
    const [page, setPage] = useState(1);
    const [totalItem, setTotalItem] = useState(0);
    const [popupOpen, setPopupOpen] = useState(false);
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [name, setName] = useState('');

    const navigate = useNavigate();

    useEffect(() => {
        getMilkCompanyList();
    }, []);

    useEffect(() => {
        getMilkDistributorList();
        
    }, [page, fromDate,toDate, name]);


    const handlePageChange  = (pageNumber) => {
        setPage(pageNumber);
    }

    const getMilkDistributorList = async () => {
        setPopupOpen(true);
        const response = await axios.get(`${baseUrl}/admin/farm/milk/distributor/list?page=${page}&limit=${limit}&fromDate=${fromDate}&toDate=${toDate}&name=${name}`);
        setPopupOpen(false);
        setDistributorList(response.data.data);
        setTotalItem(response.data.totalItem);
    }

    const deleteDistributor = async (id) => {
        try {
            await axios.delete(`${baseUrl}/admin/farm/milk/distributor/delete/${id}`);
            window.location.reload();
        } catch (error) {
            console.log(error);
        }

    };

    const getMilkCompanyList = async () => {
        setPopupOpen(true);
        const condition = `company_type = 1 AND (product_type =  7) AND status = 1`;
        const response = await axios.get(`${baseUrl}/admin/profile/company/company_list?condition=${condition}`);
        setCompanyList(response.data.data);
        setPopupOpen(false);
    }

    const editDistributor = async (id) => {
        navigate(`/admin/farm/milk/distributor/edit/${btoa(id)}`, { state: distributorList.filter(item => item.id == id) });
    }

    const handelFilterChange= (fromDate, toDate, clear, today, name) => {
        setFromDate(fromDate);
        setToDate(toDate);  
        setName(name);
    };

    const companyName = (type) => {
       
        return companyList.find((val) => val.id == type)?.name ?? "";
    }
   

    const exportToExcel = async () => {
        setPopupOpen(true);
    
        const response = await axios.get(`${baseUrl}/admin/farm/milk/distributor/list?page=${page}&limit=${limit}&fromDate=${fromDate}&toDate=${toDate}&name=${name}&type=true`);
        setPopupOpen(false);
    
        const exportData = response.data.data.map((item) => ({
            Date: item.date,
            "Company Name": companyName(item.company_id),
            "Animal Type": animalType.find((val) => val.value == item.animal_type)?.label ?? "",
            "Product Quantity": item.product_quantity,
            "Product Price": item.product_price,
        }));
    
        const totalQty = exportData.reduce((sum, row) => sum + parseFloat(row["Product Quantity"] || 0), 0);
        const totalPrice = exportData.reduce((sum, row) => sum + parseFloat(row["Product Price"] || 0), 0);
    
        // Add total row
        exportData.push({
            Date: '',
            "Company Name": '',
            "Animal Type": 'Total',
            "Product Quantity": totalQty.toFixed(2),
            "Product Price": totalPrice.toFixed(2),
        });
    
        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'DistributorList');
        XLSX.writeFile(workbook, 'Distributor_List.xlsx');
    };
    

    return (
        
        <div className="p-4">
            {popupOpen && (
                     <Loader /> 
                ) }
            <div className="flex justify-between items-center py-4 px-6">
                <h1 className="text-lg sm:text-xl md:text-xl lg:text-xl xl:text-2xl font-bold">Distributor List</h1>
                <div>
                <button
            onClick={exportToExcel}
            className="px-4 py-2 bg-green-700 text-white rounded-md mr-2 hover:bg-green-600 focus:outline-none focus:ring focus:ring-green-200"
        >
            Export to Excel
        </button>
                    <Link to="/admin/farm/milk/distributor/add">
                        <button className="px-4 py-2 bg-blue-900 text-white rounded-md mr-4 hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200">Add Distributor</button>
                    </Link>
                </div>
            </div>
            
            <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
            <DateFilter 
                handleFilterChange={handelFilterChange} 
            />
                <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                    <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                        <tr>
                        <th scope="col" className="px-6 py-3 border">Date</th>
                        <th scope="col" className="px-6 py-3 border">Company Name</th>
                        <th scope="col" className="px-6 py-3 border">Animal Type</th>
                        <th scope="col" className="px-6 py-3 border">Product Quantity</th>
                        <th scope="col" className="px-6 py-3 border">Product Price</th>
                        <th scope="col" className="px-6 py-3 border">Action</th>
                        </tr>
                       
                    </thead>
                    <tbody>
                    {distributorList.map((item) => (
                        <tr key={item.id} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                            <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">{item.date}</th>
                            <td className="px-6 py-4">{companyName(item.company_id)}</td>
                            <td className="px-6 py-4">{animalType.find((val) => val.value == item.animal_type)?.label ?? ""}</td>
                            <td className="px-6 py-4">{item.product_quantity}</td>
                            <td className="px-6 py-4">{item.product_price}</td>
                            <td className="px-6 py-4 flex">
                                    <a 
                                    onClick={() => editDistributor(item.id)}
                                    className="font-medium text-blue-600 dark:text-blue-500 hover:underline mr-2">
                                        <PencilIcon className="w-4 h-4 inline-block" /> {/* Edit icon */}
                                    </a>
                                    <a href="#" onClick={() => deleteDistributor(item.id)} className="font-medium text-red-600 dark:text-red-500 hover:underline">
                                        <XCircleIcon className="w-4 h-4 inline-block" /> 
                                    </a>
                                </td>
                        </tr>))}
           
                    </tbody>
                </table>
            </div>
            {totalItem > limit && (<Pagination
              activePage={page}
              itemsCountPerPage={limit}
              totalItemsCount={totalItem}
              pageRangeDisplayed={5}
              onChange={handlePageChange.bind(this)}
            />)}
        </div>
  );
}

export default List;